import React from 'react'
import { ListingPageProps, Labels } from './listingPage.props'

import {
  LocalLabelsProvider,
  ListingPageProvider,
  useConfigState,
} from '@sentecacommerce-theme/lib'

import { ListingPageComponent } from './Components/ListingPage'
import { ListingSEO } from './Components/ListingSEO'

export const ListingPage = ({
  seoAggregates,
  aggregates,
  sortOptions,
  defaultSortKey,
  categoryTreeConfig,
  labels,
  notFound,
  SEO,
}: ListingPageProps) => {
  const { listing } = useConfigState()

  return (
    <ListingPageProvider
      config={{
        seoAggregates,
        aggregates,
        categoryTreeConfig,
        sortOptions,
        defaultSortKey,
        productsPerPage: 24,
        filterExtension: listing.filterExtension,
      }}
    >
      <LocalLabelsProvider<Labels> labels={labels}>
        <ListingSEO data={SEO} />
        <ListingPageComponent notFound={notFound} />
      </LocalLabelsProvider>
    </ListingPageProvider>
  )
}
